import es from './es/index.js';
import ca from './ca/index.js';
import en from './en/index.js';
import it from './it/index.js';

export const LOCALE_ES = 'es';
export const LOCALE_EN = 'en';
export const LOCALE_CA = 'ca';
export const LOCALE_IT = 'it';

export default {
  [LOCALE_ES]: {
    code: LOCALE_ES,
    name: 'Español',
    flag: '<svg width="24px" viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg"><path fill="#f1b31c" d="M5 17h62v38H5z"/><path fill="#d22f27" d="M23 33v7a2.006 2.006 0 0 1-2 2h-4a2.006 2.006 0 0 1-2-2v-7M5 17h62v9H5zM5 46h62v9H5z"/><path fill="#f1b31c" d="M19 33h4v4h-4z"/><circle cx="19" cy="37" r="1.5" fill="#6a462f"/><g fill="none" stroke="#6a462f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M27 33v9M11 33v9M15 30a8.568 8.568 0 0 1 4-1M23 30a8.568 8.568 0 0 0-4-1M15 33h8M23 33v7a2.006 2.006 0 0 1-2 2h-4a2.006 2.006 0 0 1-2-2v-7M10 42h2M26 42h2"/></g><path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 17h62v38H5z"/></svg>',
    message: es,
  },
  [LOCALE_CA]: {
    code: LOCALE_CA,
    name: 'Català',
    flag: '<svg width="16px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72"><path fill="#f1b31c" d="M5 17h62v38H5z"/><path fill="#d22f27" d="M5 22h62v4H5zM5 30h62v4H5zM5 38h62v4H5zM5 46h62v4H5z"/><path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 17h62v38H5z"/></svg>',
    message: ca,
  },
  [LOCALE_EN]: {
    code: LOCALE_EN,
    name: 'English',
    flag: '<svg width="24px" viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg"><path fill="#1e50a0" d="M5 17h62v38H5z"/><path fill="#fff" d="M40 28.856V32h10.181L67 21.691V17h-7.654L40 28.856z"/><path fill="#d22f27" d="M67 17h-3.827L40 31.203V32h3.482L67 17.586V17z"/><path fill="#fff" d="M59.347 55H67v-4.692L50.182 40H40v3.143L59.347 55z"/><path fill="#d22f27" d="M67 55v-2.347L46.355 40h-4.787l24.474 15H67z"/><path fill="#fff" d="M32 43.144V40H21.819L5 50.309V55h7.654L32 43.144z"/><path fill="#d22f27" d="M5 55h3.827L32 40.797V40h-3.482L5 54.414V55z"/><path fill="#fff" d="M12.653 17H5v4.692L21.818 32H32v-3.143L12.653 17z"/><path fill="#d22f27" d="M5 17v2.347L25.646 32h4.786L5.958 17H5z"/><path fill="#fff" d="M5 31h62v10H5z"/><path fill="#fff" d="M31 17h10v38H31z"/><path fill="#d22f27" d="M5 33h62v6H5z"/><path fill="#d22f27" d="M33 17h6v38h-6z"/><path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 17h62v38H5z"/></svg>',
    message: en,
  },
  [LOCALE_IT]: {
    code: LOCALE_IT,
    name: 'Italiano',
    flag: '<svg width="24px" viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg"><path fill="#fff" d="M5 17h62v38H5z"/><path fill="#5c9e31" d="M5 17h21v38H5z"/><path fill="#d22f27" d="M46 17h21v38H46z"/><path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 17h62v38H5z"/></svg>',
    message: it,
  },
};
